// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order_Order__2Pu9k","Ingredients":"Order_Ingredients__2ZaEm"};